<template>
  <div v-if="headers.length > 0">
    <div v-if="headers.length === 1">
      <section 
        class="section cta-section grid grid-cols-2 sm-grid-cols-1 md-grid-cols-1" 
        :style="headers[0].backgroundImage ? `background: linear-gradient(#101823ac, #101823ac), url('${headers[0].backgroundImage}');` : ''"
      >
        <div class="text">
            <h3 class="section-header">{{ headers[0].heading }}</h3>
            <h2>{{ headers[0].title }}</h2>
            <div v-html="headers[0].content"></div>
        </div>
        <div class="video" v-if="headers[0].video">
            <router-link :to="{ name: 'video-detail', params: { slug: headers[0].video.slug }}">
                <img :src="headers[0].video.thumbnail" :alt="headers[0].video.title">
            </router-link>
        </div>
      </section>
    </div>
    <swiper
      v-else
      :modules="modules"
      :slides-per-view="1"
      :space-between="0"
      :loop="true"
      :pagination="{ clickable: true }"
      :navigation="true"
      :autoplay="{ delay: 5000, disableOnInteraction: false }"
      class="header-swiper"
    >
      <swiper-slide v-for="(header, index) in headers" :key="index">
         <section 
        class="section cta-section grid grid-cols-2 sm-grid-cols-1 md-grid-cols-1" 
        :style="header.backgroundImage ? `background: linear-gradient(#101823ac, #101823ac), url('${header.backgroundImage}');` : ''"
      >
        <div class="text">
            <h3 class="section-header">{{ header.heading }}</h3>
            <h2>{{ header.title }}</h2>
            <div v-html="header.content"></div>
        </div>
        <div class="video" v-if="header.video">
            <router-link :to="{ name: 'video-detail', params: { slug: header.video.slug }}">
                <img :src="header.video.thumbnail" :alt="header.video.title">
            </router-link>
        </div>
      </section>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { HeaderData } from '@/services/PageService';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default defineComponent({
  name: 'PageHeader',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    headers: {
      type: Array as PropType<HeaderData[]>,
      required: true,
    }
  },
  setup() {
      return {
          modules: [Navigation, Pagination, Autoplay],
      };
  },
});
</script>

<style scoped>
.header-swiper {
  width: 100%;
}
</style>
